"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeTimeFunction = void 0;
var tslib_1 = require("tslib");
var IkeTimeFunction = /** @class */ (function () {
    function IkeTimeFunction() {
    }
    /**
     * Execute a function and measure how long it took.
     * @param func the function to measure execution time of
     */
    IkeTimeFunction.timeFunction = function (func) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var startTime;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = Date.now();
                        return [4 /*yield*/, func()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Date.now() - startTime];
                }
            });
        });
    };
    return IkeTimeFunction;
}());
exports.IkeTimeFunction = IkeTimeFunction;
//# sourceMappingURL=time.function.js.map